// import React, { useState, useEffect, useRef } from "react";
// import {
//   getMyBookings,
//   cancelBooking,
//   rescheduleBooking,
//   diagReschedule,
//   packageReschedule,
// } from "../api/bookings.api";
// import { getWallet } from "../api/staff.api";
// import { apiErrorMessage } from "../utils/apiError";
// import { AddToCalendar, CalendarWhen, ViewDirections, normalizeRating } from "../utils/bookingModels";
// import { getDiagnosticSlots } from "../api/diagnostics.api";
// import { getDoctorSlots } from "../api/doctors.api";
// import { getStaffId } from "../utils/storage";
// import Header from "../Components/Header";
// import Footer from "../Components/Footer";
// import Modal from "../Popups/Modal";
// import ConfirmModal from "../Popups/ConfirmModal";
// import EmptyState from "../Components/States/EmptyState";
// import LoadingState from "../Components/States/LoadingState";
// import OfflineState from "../Components/States/OfflineState";
// import { isNetworkError } from "../utils/network";
// import { toast } from "../Components/Toast";
// import { FaMapMarkerAlt, FaFlask, FaXRay, FaStethoscope, FaBox, FaChevronRight, FaCalendarAlt, FaClipboard } from "react-icons/fa";

// const FILTER_TABS = [
//   { id: "all", label: "All" },
//   { id: "package", label: "Packages", icon: FaBox },
//   { id: "doctor", label: "Doctor", icon: FaStethoscope },
//   { id: "xray", label: "Scans", icon: FaXRay },
//   { id: "test", label: "Lab Tests", icon: FaFlask },
// ];
// const FILTER_LABEL = { all: "", package: "Package", doctor: "Doctor", xray: "Scan/X-Ray", test: "Lab Test" };

// const DetailRow = ({ icon: Icon, label, value }) => (
//   <div className="flex items-start justify-between gap-3 py-2.5 border-b border-surface-container/60 last:border-0">
//     <span className="flex items-center gap-2 text-sm font-semibold text-on-primary-fixed-var shrink-0">
//       <Icon className="text-primary shrink-0" size={14} />
//       {label}
//     </span>
//     <span className="text-sm text-on-surface-variant text-right break-words">{value}</span>
//   </div>
// );

// const filterPillClass = (active) =>
//   active
//     ? "bg-primary text-white shadow-sm"
//     : "bg-surface-lowest text-on-primary-fixed-var border border-primary-fixed-dim/50 hover:bg-surface-low";

// const getDiagnosticTitle = (booking, bookingType) => {
//   if (booking.cartItems?.length > 0) return booking.cartItems[0].title;
//   const kind = bookingType === "xray" ? "X-Ray/Scan" : bookingType === "test" ? "Lab Test" : "Diagnostic";
//   if (booking.serviceType === "Home Collection") return `${kind} (Home Collection)`;
//   if (booking.serviceType === "Center Visit") return `${kind} (Center Visit)`;
//   return `${kind} Consultation`;
// };

// const getPriceLabel = (bookingType) => {
//   if (bookingType === "package") return "Package Price";
//   if (bookingType === "doctor") return "Consultation Fee";
//   if (bookingType === "xray") return "Scan Cost";
//   if (bookingType === "test") return "Test Cost";
//   return "Total Cost";
// };

// const MyBookings = () => {
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [networkError, setNetworkError] = useState(false);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [showCancelConfirm, setShowCancelConfirm] = useState(false);
//   const [showReschedule, setShowReschedule] = useState(false);
//   const [availableSlots, setAvailableSlots] = useState([]);
//   const [loadingSlots, setLoadingSlots] = useState(false);
//   const [selectedSlot, setSelectedSlot] = useState("");
//   const staffId = getStaffId();
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedDateString, setSelectedDateString] = useState("");

//   // Filter state
//   const [filter, setFilter] = useState('all');

//   // Refs for real‑time values
//   const selectedDateStringRef = useRef("");
//   const selectedBookingRef = useRef(null);

//   // Helper: Check if booking can be modified (reschedule/cancel)
//   const isBookingModifiable = (booking) => {
//     if (!booking) return false;
//     // Already cancelled – no buttons
//     if (booking.status === "Cancelled" || booking.status === "Completed") return false;

//     try {
//       // Combine booking date and time slot into a local datetime string
//       const bookingDateTimeStr = `${booking.date}T${booking.timeSlot}:00`;
//       const bookingDateTime = new Date(bookingDateTimeStr);
//       const now = new Date();

//       // Return true only if the booking datetime is strictly in the future
//       return bookingDateTime > now;
//     } catch (error) {
//       console.error("Date parsing error:", error);
//       return false;
//     }
//   };

//   useEffect(() => {
//     if (!staffId) {
//       setError("Staff ID is missing. Please log in again.");
//       setLoading(false);
//       return;
//     }
//     fetchBookings();
//   }, [staffId]);

//   const fetchBookings = async () => {
//     try {
//       setLoading(true);
//       setNetworkError(false);
//       setError(null);
//       const response = await getMyBookings(staffId);
//       if (response.data.success) {
//         setBookings(response.data.bookings);
//       } else {
//         setError("Failed to fetch bookings");
//       }
//     } catch (err) {
//       if (isNetworkError(err)) setNetworkError(true);
//       else {
//         setError(
//           "Error fetching bookings: " +
//           (err.response?.data?.message || err.message)
//         );
//       }
//       console.error("Booking fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getBookingType = (booking) => {
//     if (booking.package && booking.package._id) {
//       return 'package';
//     }
//     if (booking.doctorConsultationBookingId || booking.doctorId) {
//       return 'doctor';
//     }
//     if (booking.diagnosticBookingId) {
//       if (booking.cartItems && booking.cartItems.length > 0) {
//         const hasXray = booking.cartItems.some(item => item.type === "xray");
//         const hasTest = booking.cartItems.some(item => item.type === "test");
//         if (hasXray && !hasTest) return 'xray';
//         if (hasTest && !hasXray) return 'test';
//         if (hasXray && hasTest) return 'diagnostic';
//       }
//       return 'diagnostic';
//     }
//     return 'other';
//   };

//   const filteredBookings = bookings.filter(booking => {
//     if (filter === 'all') return true;
//     const bookingType = getBookingType(booking);
//     if (filter === 'package') return bookingType === 'package';
//     if (filter === 'doctor') return bookingType === 'doctor';
//     if (filter === 'diagnostic') return bookingType === 'diagnostic' || bookingType === 'test' || bookingType === 'xray';
//     if (filter === 'xray') return bookingType === 'xray';
//     if (filter === 'test') return bookingType === 'test';
//     return true;
//   });

//   const refundLabel = (bucket) => {
//     if (bucket === "forDoctors") return "doctors";
//     if (bucket === "forPackages") return "packages";
//     if (bucket === "forTests") return "tests";
//     return "wallet";
//   };

//   const handleCancelBooking = async (booking) => {
//     try {
//       const response = await cancelBooking(staffId, booking.bookingId || booking._id, {
//         status: "Cancelled",
//       });
//       const data = response.data || {};
//       const amount = data.refundedAmount;
//       if (amount != null && amount !== "") {
//         toast.success(`₹${amount} refunded to your ${refundLabel(data.refundedTo)} wallet`);
//       } else {
//         toast.success(data.message || "Booking successfully cancelled.");
//       }
//       fetchBookings();
//       getWallet().catch(() => {});
//       setSelectedBooking(null);
//     } catch (error) {
//       console.error("Cancel Error:", error);
//       toast.error(apiErrorMessage(error, "Error while cancelling booking."));
//     }
//   };

//   const formatDateForAPI = (date) => {
//     if (!date) return '';
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const formatDateForDisplay = (dateString) => {
//     if (!dateString) return '';
//     const d = new Date(dateString);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const fetchAvailableSlots = async (dateToUse = null) => {
//     const dateString = dateToUse || selectedDateStringRef.current;
//     const booking = selectedBookingRef.current;
//     if (!booking || !dateString) return;

//     setLoadingSlots(true);
//     try {
//       let response;
//       if (booking.diagnosticBookingId && booking.serviceType) {
//         const diagnosticId = booking.diagnostic?.diagnosticId?._id;
//         if (!diagnosticId) {
//           toast.error("Diagnostic center information not found.");
//           return;
//         }
//         response = await getDiagnosticSlots(diagnosticId, dateString, booking.serviceType);
//         if (response.data.slots && response.data.slots.length > 0) {
//           setAvailableSlots(response.data.slots);
//         } else if (response.data.homeCollectionSlots || response.data.centerVisitSlots) {
//           const slots = booking.serviceType === "Home Collection"
//             ? response.data.homeCollectionSlots
//             : response.data.centerVisitSlots;
//           setAvailableSlots(slots || []);
//         } else {
//           setAvailableSlots([]);
//         }
//       }
//       else if (booking.doctorId) {
//         response = await getDoctorSlots(booking.doctorId, dateString, booking.type);
//         setAvailableSlots(response.data.slots || []);
//       } else {
//         toast.error("Cannot reschedule this booking type");
//         return;
//       }
//     } catch (error) {
//       console.error("Error fetching slots:", error);
//       setAvailableSlots([]);
//     } finally {
//       setLoadingSlots(false);
//     }
//   };

//   const confirmReschedule = async () => {
//     const dateString = selectedDateStringRef.current;
//     const booking = selectedBookingRef.current;
//     if (!booking || !dateString || !selectedSlot) {
//       toast.error("Please select a date and slot before confirming.");
//       return;
//     }

//     try {
//       let response;
//       const bookingId = booking.bookingId || booking._id;
//       if (booking.packageId || booking.packageBookingId) {
//         response = await packageReschedule(staffId, bookingId, {
//           newDate: dateString,
//           newTimeSlot: selectedSlot,
//         });
//       } else if (booking.diagnosticBookingId) {
//         response = await diagReschedule(staffId, bookingId, {
//           newDate: dateString,
//           newTimeSlot: selectedSlot,
//           serviceType: booking.serviceType,
//         });
//       } else {
//         response = await rescheduleBooking(staffId, bookingId, {
//           newDay: new Date(dateString).toLocaleDateString("en-US", { weekday: "long" }),
//           newDate: dateString,
//           newTimeSlot: selectedSlot,
//         });
//       }
//       if (response.data.isSuccessfull || response.data.success) {
//         const data = response.data;
//         setBookings((prev) => prev.map((item) => {
//           const id = item.bookingId || item._id;
//           if (id !== bookingId) return item;
//           return {
//             ...item,
//             calendar: data.calendar ?? data.booking?.calendar ?? item.calendar,
//             locationUrl: data.locationUrl ?? data.booking?.locationUrl ?? item.locationUrl,
//           };
//         }));
//         toast.success("Booking rescheduled successfully.");
//         fetchBookings();
//         setShowReschedule(false);
//         setSelectedBooking(null);
//         selectedBookingRef.current = null;
//         setSelectedSlot("");
//         setAvailableSlots([]);
//         setSelectedDateString("");
//         selectedDateStringRef.current = "";
//       } else {
//         toast.error(response.data.message || "Failed to reschedule booking.");
//       }
//     } catch (error) {
//       console.error("Reschedule Error:", error);
//       toast.error("Error while rescheduling booking: " + (error.response?.data?.message || error.message));
//     }
//   };

//   const openGoogleMaps = (address) => {
//     if (!address) {
//       toast.error("Address not available");
//       return;
//     }
//     const encodedAddress = encodeURIComponent(address);
//     const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
//     window.open(googleMapsUrl, '_blank');
//   };

//   const handleRescheduleClick = (booking) => {
//     selectedBookingRef.current = booking;
//     const bookingDate = new Date(booking.date);
//     const dateString = formatDateForAPI(bookingDate);
//     selectedDateStringRef.current = dateString;

//     setSelectedBooking(booking);
//     setSelectedDate(bookingDate);
//     setSelectedDateString(dateString);
//     setSelectedSlot("");
//     setAvailableSlots([]);
//     setShowReschedule(true);
//     fetchAvailableSlots(dateString);
//   };

//   const handleDateSelect = (date) => {
//     const dateString = formatDateForAPI(date);
//     selectedDateStringRef.current = dateString;
//     setSelectedDate(date);
//     setSelectedDateString(dateString);
//     setSelectedSlot("");
//     fetchAvailableSlots(dateString);
//   };

//   const generateDateOptions = () => {
//     const dates = [];
//     const today = new Date();
//     for (let i = 0; i < 7; i++) {
//       const date = new Date(today);
//       date.setDate(today.getDate() + i);
//       dates.push(date);
//     }
//     return dates;
//   };

//   const getBookingBadge = (booking) => {
//     const bookingType = getBookingType(booking);
//     switch (bookingType) {
//       case "package":
//         return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaBox className="w-3 h-3 mr-1" />, label: "PACKAGE" };
//       case "doctor":
//         return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaStethoscope className="w-3 h-3 mr-1" />, label: "DOCTOR" };
//       case "xray":
//         return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaXRay className="w-3 h-3 mr-1" />, label: "X-RAY/SCAN" };
//       case "test":
//         return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaFlask className="w-3 h-3 mr-1" />, label: "LAB TEST" };
//       default:
//         return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaFlask className="w-3 h-3 mr-1" />, label: "DIAGNOSTIC" };
//     }
//   };

//   const getItemTypeBadge = (item) => {
//     if (item.type === "xray") {
//       return <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-medium rounded-full flex items-center w-fit"><FaXRay className="w-3 h-3 mr-1" />X-RAY/SCAN</span>;
//     } else if (item.type === "test") {
//       return <span className="px-2 py-1 bg-primary-fixed/40 text-primary-container text-xs font-medium rounded-full flex items-center w-fit"><FaFlask className="w-3 h-3 mr-1" />LAB TEST</span>;
//     }
//     return null;
//   };

//   const renderBookingCard = (booking) => {
//     const badge = getBookingBadge(booking);
//     const bookingType = getBookingType(booking);
//     const amount = booking.payableAmount || booking.totalPrice || "—";
//     const bookingId = booking.diagnosticBookingId || booking.doctorConsultationBookingId || booking.bookingId || "—";
//     const dateTime = `${formatDateForDisplay(booking.date)}${booking.timeSlot ? `, ${booking.timeSlot}` : ""}`;

//     let title;
//     let detailRows;
//     let highlight = null;

//     if (bookingType === "package") {
//       title = booking.package?.name || "Health Package";
//       detailRows = [
//         { icon: FaFlask, label: "Total Tests", value: booking.package?.totalTestsIncluded || 0 },
//         { icon: FaMapMarkerAlt, label: "Type", value: booking.serviceType || "Diagnostic" },
//         { icon: FaClipboard, label: "Booking ID", value: bookingId },
//         { icon: FaCalendarAlt, label: "Date & Time", value: dateTime },
//       ];
//       if (booking.package) {
//         highlight = (
//           <div className="bg-primary-fixed/30 rounded-xl p-4 text-center">
//             <p className="text-sm font-semibold text-on-primary-fixed-var">
//               Package Includes {booking.package.totalTestsIncluded} Tests
//             </p>
//             <p className="text-xs text-on-surface-variant mt-1 leading-relaxed">
//               Comprehensive health screening package
//             </p>
//           </div>
//         );
//       }
//     } else if (bookingType === "doctor") {
//       title = booking.doctor?.name || "Doctor Consultation";
//       detailRows = [
//         {
//           icon: FaStethoscope,
//           label: "Consultation",
//           value: booking.type === "Online" ? "Online" : booking.type === "Offline" ? "Clinic Visit" : "Consultation",
//         },
//         { icon: FaClipboard, label: "Booking ID", value: bookingId },
//         { icon: FaCalendarAlt, label: "Date & Time", value: dateTime },
//       ];
//       if (booking.doctor?.specialization) {
//         detailRows.push({ icon: FaStethoscope, label: "Specialization", value: booking.doctor.specialization });
//       }
//     } else {
//       title = getDiagnosticTitle(booking, bookingType);
//       const itemCount = booking.cartItems?.length || 0;
//       detailRows = [
//         { icon: FaFlask, label: "Total Items", value: itemCount || "—" },
//         {
//           icon: FaMapMarkerAlt,
//           label: "Type",
//           value: booking.serviceType === "Home Collection" ? "Home Collection" : "Center Visit",
//         },
//         { icon: FaClipboard, label: "Booking ID", value: bookingId },
//         { icon: FaCalendarAlt, label: "Date & Time", value: dateTime },
//       ];
//       // if (booking.serviceType === "Center Visit" && booking.diagnostic?.address) {
//       //   highlight = (
//       //     <div className="bg-primary-fixed/30 rounded-xl p-4 text-center">
//       //       <p className="text-xs text-on-surface-variant mb-1">Center Address</p>
//       //       <button
//       //         type="button"
//       //         onClick={() => openGoogleMaps(booking.diagnostic.address)}
//       //         className="text-sm font-medium text-primary hover:underline leading-relaxed break-words"
//       //       >
//       //         {booking.diagnostic.address}
//       //       </button>
//       //     </div>
//       //   );
//       // }
//     }

//     return (
//       <div
//         key={booking.bookingId || booking._id}
//         className="rounded-2xl border border-surface-container bg-surface-lowest shadow-sm p-4 space-y-3"
//       >
//         <div>
//           <div className="flex items-center justify-between">
//             <span className={`inline-flex items-center ${badge.bg} ${badge.text} text-xs font-semibold px-2.5 py-1 rounded-md mb-2`}>
//               {badge.icon}
//               {badge.label}
//             </span>
//             <span
//               className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${booking.status === "Cancelled" ? "bg-error-container text-error" : "bg-primary-fixed/30 text-primary"
//                 }`}
//             >
//               {booking.status}
//             </span>
//           </div>
//           <div className="flex items-start justify-between gap-3 mt-2">
//             <h3 className="font-bold text-on-primary-fixed-var text-base leading-snug break-words flex-1">{title}</h3>
//             <div className="text-right shrink-0">
//               <p className="text-lg font-bold text-primary">₹{amount}</p>
//               <p className="text-xs text-on-surface-variant">{getPriceLabel(bookingType)}</p>
//             </div>
//           </div>
//         </div>

//         <div className="border-t border-surface-container/60 pt-1">
//           {detailRows.map((row) => (
//             <DetailRow key={row.label} icon={row.icon} label={row.label} value={row.value} />
//           ))}
//         </div>

//         {highlight}

//         <div className="border-t border-surface-container/60 pt-3 space-y-2">
//           <p className="font-bold text-on-primary-fixed-var">₹{amount}</p>
//           <p className="text-sm text-on-surface-variant">
//             {formatDateForDisplay(booking.date)}
//             {booking.timeSlot ? ` · ${booking.timeSlot}` : ""}
//           </p>
//           <button
//             type="button"
//             onClick={() => setSelectedBooking(booking)}
//             className="w-full min-h-[48px] bg-primary text-white rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-primary-container transition-colors"
//           >
//             Booking Details
//             <FaChevronRight size={12} />
//           </button>
//         </div>
//       </div>
//     );
//   };

//   const renderPackageBookingDetails = (booking) => {
//     const badge = getBookingBadge(booking);
//     return (
//       <div className="space-y-4 text-sm">
//         <div className={`${badge.bg} p-3 rounded-lg`}>
//           <div className="flex items-center">{badge.icon}<span className="font-bold ml-2">{badge.label}</span></div>
//         </div>
//         <div className="bg-surface-low p-4 rounded-lg">
//           <h4 className="font-bold text-on-primary-fixed-var text-base mb-3">{booking.package?.name}</h4>
//           <div className="grid grid-cols-2 gap-4 py-3 border-b border-surface-container">
//             <div><p className="text-xs text-on-surface-variant mb-1">Total Tests</p><p className="font-semibold text-primary">{booking.package?.totalTestsIncluded}</p></div>
//             <div><p className="text-xs text-on-surface-variant mb-1">Service Type</p><p className="font-semibold">{booking.serviceType}</p></div>
//             <div><p className="text-xs text-on-surface-variant mb-1">Original Price</p><p className="font-semibold">₹{booking.package?.price}</p></div>
//             <div><p className="text-xs text-on-surface-variant mb-1">Paid Amount</p><p className="font-semibold text-primary">₹{booking.payableAmount}</p></div>
//           </div>
//           {booking.package?.description && (
//             <div className="mt-3 pt-3"><p className="text-xs text-on-surface-variant mb-1">Description</p><p className="text-sm text-on-primary-fixed-var leading-relaxed">{booking.package.description}</p></div>
//           )}
//         </div>
//         <div className="space-y-3">
//           <div className="flex justify-between"><span className="font-semibold">Booking ID</span><span className="font-mono">{booking.diagnosticBookingId || booking.bookingId}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Date & Time</span><span>{formatDateForDisplay(booking.date)} - {booking.timeSlot}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Status</span><span className={`font-semibold ${booking.status === 'Confirmed' ? 'text-primary' : 'text-yellow-600'}`}>{booking.status}</span></div>
//         </div>
//         {booking.staff && (
//           <div className="bg-primary-fixed/30 p-3 rounded mt-3"><p className="text-xs text-on-surface-variant mb-1">Booked By</p><p className="font-medium">{booking.staff.name}</p><p className="text-sm text-on-surface-variant">{booking.staff.email}</p></div>
//         )}
//       </div>
//     );
//   };

//   const renderDiagnosticBookingDetails = (booking) => {
//     const badge = getBookingBadge(booking);
//     return (
//       <div className="space-y-4 text-sm">
//         <div className={`${badge.bg} p-3 rounded-lg`}>
//           <div className="flex items-center">{badge.icon}<span className="font-bold ml-2">{badge.label}</span></div>
//         </div>
//         <div className="space-y-3">
//           <div className="flex justify-between"><span className="font-semibold">Service Type</span><span>{booking.serviceType === "Home Collection" ? "Home Collection" : "Center Visit"}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Booking ID</span><span className="font-mono">{booking.diagnosticBookingId}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Date & Time</span><span>{formatDateForDisplay(booking.date)} - {booking.timeSlot}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Total Amount</span><span className="font-semibold text-primary">₹{booking.payableAmount || booking.totalPrice}</span></div>
//         </div>
//         {booking.diagnostic && (
//           <div className="bg-surface-low p-3 rounded-lg">
//             <p className="text-xs text-on-surface-variant mb-1">Diagnostic Center</p>
//             <p className="font-semibold">{booking.diagnostic.name}</p>
//             {booking.serviceType === "Center Visit" && booking.diagnostic.address && (
//               <div className="mt-2"><p className="text-xs text-on-surface-variant mb-1">Address</p><p className="text-sm text-primary-container cursor-pointer hover:text-primary transition-colors" onClick={() => openGoogleMaps(booking.diagnostic.address)}><FaMapMarkerAlt className="inline-block mr-1" />{booking.diagnostic.address}</p></div>
//             )}
//           </div>
//         )}
//         {booking.cartItems && booking.cartItems.length > 0 && (
//           <div className="bg-surface-lowest border rounded-lg p-3">
//             <p className="font-semibold mb-2">Booked Items</p>
//             <div className="space-y-2 max-h-60 overflow-y-auto">
//               {booking.cartItems.map((item, index) => (
//                 <div key={index} className="border-b pb-2 last:border-0">
//                   <div className="flex justify-between items-start">
//                     <div className="flex-1">
//                       <div className="flex items-center mb-1">{getItemTypeBadge(item)}<span className="ml-2 font-medium">{item.title}</span></div>
//                       <div className="grid grid-cols-2 gap-2 text-xs text-on-surface-variant">
//                         <div>Quantity: {item.quantity}</div>
//                         <div>Price: ₹{item.price}</div>
//                         <div>Offer: ₹{item.offerPrice}</div>
//                         <div>Total: ₹{item.totalPrice}</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//               <div className="pt-2 border-t mt-2"><div className="flex justify-between font-semibold"><span>Total Items:</span><span>{booking.cartItems.length}</span></div><div className="flex justify-between font-semibold text-primary"><span>Total Amount:</span><span>₹{booking.payableAmount || booking.totalPrice}</span></div></div>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const renderDoctorBookingDetails = (booking) => {
//     const badge = getBookingBadge(booking);
//     return (
//       <div className="space-y-4 text-sm">
//         <div className={`${badge.bg} p-3 rounded-lg`}>
//           <div className="flex items-center">{badge.icon}<span className="font-bold ml-2">{badge.label}</span></div>
//         </div>
//         <div className="space-y-3">
//           <div className="flex justify-between"><span className="font-semibold">Consultation Type</span><span>{booking.type === "Online" ? "Online Consultation" : "Clinic Visit"}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Booking ID</span><span className="font-mono">{booking.doctorConsultationBookingId || booking.bookingId}</span></div>
//           <div className="flex justify-between"><span className="font-semibold">Date & Time</span><span>{formatDateForDisplay(booking.date)} - {booking.timeSlot}</span></div>
//           {booking.patient && <div className="flex justify-between"><span className="font-semibold">Family Member</span><span>{booking.patient.name}</span></div>}
//           <div className="flex justify-between"><span className="font-semibold">Consultation Fee</span><span className="font-semibold text-primary">₹{booking.payableAmount || booking.totalPrice}</span></div>
//         </div>
//         {booking.doctor && (
//           <div className="bg-surface-low p-3 rounded-lg">
//             <p className="text-xs text-on-surface-variant mb-1">Doctor Details</p>
//             <p className="font-semibold">{booking.doctor.name}</p>
//             {normalizeRating(booking.doctor.rating) > 0 && (
//               <p className="text-sm text-on-surface-variant">Rating {normalizeRating(booking.doctor.rating).toFixed(1)}</p>
//             )}
//             <p className="text-sm text-on-surface-variant">{booking.doctor.qualification}</p>
//             <p className="text-sm text-on-surface-variant">{booking.doctor.specialization}</p>
//             {booking.type === "Offline" && booking.doctor.address && (
//               <div className="mt-2"><p className="text-xs text-on-surface-variant mb-1">Clinic Address</p><p className="text-sm text-primary-container cursor-pointer hover:text-primary transition-colors" onClick={() => openGoogleMaps(booking.doctor.address)}><FaMapMarkerAlt className="inline-block mr-1" />{booking.doctor.address}</p></div>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   const renderBookingLinks = (booking) => {
//     const locationUrl = booking.locationUrl || booking.doctor?.locationUrl || booking.diagnostic?.locationUrl;
//     return (
//       <div className="space-y-2">
//         <CalendarWhen calendar={booking.calendar} />
//         <div className="flex flex-col sm:flex-row gap-2">
//           {/* <AddToCalendar calendar={booking.calendar} className="flex-1 text-center" /> */}
//           <ViewDirections url={locationUrl} className="flex-1 text-center" />
//         </div>
//       </div>
//     );
//   };

//   const renderBookingDetails = (booking) => {
//     const bookingType = getBookingType(booking);
//     let body = renderDiagnosticBookingDetails(booking);
//     if (bookingType === "package") body = renderPackageBookingDetails(booking);
//     else if (bookingType === "doctor") body = renderDoctorBookingDetails(booking);
//     return (
//       <div className="space-y-4">
//         {body}
//         {renderBookingLinks(booking)}
//       </div>
//     );
//   };

//   useEffect(() => {
//     selectedDateStringRef.current = selectedDateString;
//   }, [selectedDateString]);

//   useEffect(() => {
//     selectedBookingRef.current = selectedBooking;
//   }, [selectedBooking]);

//   if (loading) {
//     return <LoadingState fullPage withHeader withFooter message="Loading your bookings…" />;
//   }

//   if (networkError) {
//     return (
//       <div className="min-h-screen bg-surface-low flex flex-col">
//         <Header />
//         <OfflineState onRetry={fetchBookings} className="flex-1" />
//         <Footer />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-surface-low flex flex-col">
//         <Header />
//         <div className="flex-1 flex flex-col items-center justify-center text-lg text-red-500 px-4">
//           <p>{error}</p>
//           <button onClick={fetchBookings} type="button" className="mt-4 bg-primary text-white py-2 px-4 rounded-md">Try Again</button>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-surface-low flex flex-col">
//       <Header />
//       <div className="flex flex-col min-h-screen pb-16 lg:pb-0 flex-1">
//         <div className="max-w-2xl mx-auto w-full px-3 sm:px-4 py-4 sm:py-8">
//           <div className="sticky top-0 z-20 bg-surface-low -mx-3 px-3 pt-2 pb-3 border-b border-surface-container/60 lg:static lg:mx-0 lg:px-0 lg:border-0 lg:pb-0">
//             <h1 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var">My Bookings</h1>
//             {/* <p className="text-xs sm:text-sm text-on-surface-variant mt-0.5 font-normal">
//               View and manage your health appointments
//             </p> */}

//             <div className="relative mt-4">
//               <div className="flex gap-2 overflow-x-auto snap-x snap-mandatory pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
//                 {FILTER_TABS.map(({ id, label, icon: Icon }) => (
//                   <button
//                     key={id}
//                     type="button"
//                     onClick={() => setFilter(id)}
//                     className={`shrink-0 snap-start inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-medium min-h-[44px] transition-colors ${filterPillClass(filter === id)}`}
//                   >
//                     {Icon && <Icon className="w-3 h-3" />}
//                     {label}
//                   </button>
//                 ))}
//               </div>
//               <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-surface-low to-transparent lg:hidden" />
//               <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-surface-low to-transparent lg:hidden" />
//             </div>

//             <p className="text-xs text-on-surface-variant mt-2 text-right">
//               {filteredBookings.length} booking{filteredBookings.length !== 1 ? "s" : ""} found
//             </p>
//           </div>

//           {bookings.length === 0 ? (
//             <EmptyState
//               title="No bookings found yet."
//               description="Your health appointments will appear here once you book a consultation, lab test, or package."
//               actionLabel="Browse Lab Tests"
//               actionTo="/lab-tests"
//             />
//           ) : (
//             <div className="space-y-4 mt-4">
//               {filteredBookings.length === 0 ? (
//                 <EmptyState
//                   title={`No ${FILTER_LABEL[filter] ? FILTER_LABEL[filter] + " " : ""}bookings found`}
//                   description="Try a different filter to see your appointments."
//                   actionLabel={filter !== "all" ? "View all bookings" : undefined}
//                   onAction={filter !== "all" ? () => setFilter("all") : undefined}
//                 />
//               ) : (
//                 filteredBookings.map((booking) => renderBookingCard(booking))
//               )}
//             </div>
//           )}
//         </div>

//         {/* Booking Details Modal */}
//         <Modal
//           open={!!selectedBooking && !showReschedule}
//           onClose={() => { setSelectedBooking(null); selectedBookingRef.current = null; }}
//           className="max-w-lg w-full rounded-t-2xl sm:rounded-2xl h-[min(92vh,100%)] sm:h-auto sm:max-h-[90vh] overflow-y-auto"
//           align="bottom"
//           closeSize={24}
//         >
//           {selectedBooking && (
//             <div className="p-4 sm:p-6">
//               <h3 className="text-base sm:text-lg font-bold text-on-primary-fixed-var mb-4 pr-10">
//                 {(() => {
//                   const bookingType = getBookingType(selectedBooking);
//                   if (bookingType === 'package') return "Health Package Details";
//                   if (bookingType === 'doctor') return "Doctor Consultation Details";
//                   if (bookingType === 'xray') return "X-Ray/Scan Details";
//                   if (bookingType === 'test') return "Lab Test Details";
//                   return "Diagnostic Booking Details";
//                 })()}
//               </h3>

//               {renderBookingDetails(selectedBooking)}

//               <div className="mt-6 space-y-2">
//                 {isBookingModifiable(selectedBooking) && (
//                   <>
//                     <button
//                       onClick={() => handleRescheduleClick(selectedBooking)}
//                       className="w-full border border-primary text-primary py-2.5 rounded-xl text-sm font-semibold hover:bg-primary-fixed/30"
//                     >
//                       Reschedule Booking
//                     </button>
//                     <button
//                       onClick={() => setShowCancelConfirm(true)}
//                       className="w-full border border-red-300 text-error py-2.5 rounded-xl text-sm font-semibold hover:bg-red-50"
//                     >
//                       Cancel Booking
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>
//           )}
//         </Modal>

//         <ConfirmModal
//           open={showCancelConfirm}
//           onCancel={() => setShowCancelConfirm(false)}
//           onConfirm={() => {
//             handleCancelBooking(selectedBooking);
//             setShowCancelConfirm(false);
//             setSelectedBooking(null);
//             selectedBookingRef.current = null;
//           }}
//           title="Cancel this booking?"
//           message="Are you sure you want to cancel this booking? This action cannot be undone."
//           confirmLabel="Yes, Cancel"
//           cancelLabel="Keep Booking"
//         />

//         {/* Reschedule Modal */}
//         <Modal
//           open={showReschedule && !!selectedBooking}
//           onClose={() => { setShowReschedule(false); setSelectedSlot(""); setAvailableSlots([]); setSelectedDateString(""); selectedDateStringRef.current = ""; }}
//           className="max-w-lg w-full rounded-t-2xl sm:rounded-2xl h-[min(92vh,100%)] sm:h-auto sm:max-h-[90vh] overflow-y-auto"
//           align="bottom"
//           closeSize={24}
//         >
//           {selectedBooking && (
//             <div className="p-4 sm:p-6">
//               <h3 className="text-base sm:text-lg font-bold text-on-primary-fixed-var mb-4 pr-10">Reschedule Booking</h3>
//               <div className="bg-primary-fixed/40 p-3 rounded-md mb-4"><p className="text-sm font-semibold">Current Booking</p><p className="text-primary-container font-medium text-sm">{formatDateForDisplay(selectedBooking.date)} - {selectedBooking.timeSlot}</p></div>
//               <div className="flex space-x-2 overflow-x-auto mb-4 pb-2">
//                 {generateDateOptions().map((date, i) => {
//                   const dateString = formatDateForAPI(date);
//                   const isSelected = selectedDateStringRef.current === dateString;
//                   return (
//                     <button key={i} onClick={() => handleDateSelect(date)} className={`flex flex-col items-center min-w-[50px] px-2 py-2 rounded-md ${isSelected ? "bg-primary text-white" : "bg-surface-low text-on-primary-fixed-var"}`}>
//                       <span className="text-xs font-medium">{date.toLocaleDateString("en-US", { weekday: "short" })}</span>
//                       <span className="text-base font-semibold">{date.getDate()}</span>
//                       <span className="text-xs text-on-surface-variant">{date.getMonth() + 1}/{date.getFullYear()}</span>
//                     </button>
//                   );
//                 })}
//               </div>
//               {loadingSlots && <LoadingState size="sm" message="Loading available slots…" className="py-3" />}
//               {!loadingSlots && (
//                 <div>
//                   <p className="text-sm font-medium mb-2">Available Time Slots</p>
//                   <div className="grid grid-cols-2 gap-2 mb-4">
//                     {availableSlots.length > 0 ? (
//                       availableSlots.map((slot) => (
//                         <button key={slot._id || slot.timeSlot} onClick={() => setSelectedSlot(slot.timeSlot)} disabled={slot.isBooked} className={`p-2 rounded-md text-xs transition-colors ${slot.isBooked ? "bg-error-container text-error cursor-not-allowed" : selectedSlot === slot.timeSlot ? "bg-primary text-white" : "bg-surface-low text-on-primary-fixed-var hover:bg-surface-container"}`}>
//                           <div className="font-medium">{slot.timeSlot}</div>
//                           {slot.isBooked && <div className="text-xs mt-1 text-red-500">Booked</div>}
//                         </button>
//                       ))
//                     ) : (
//                       <div className="col-span-2 text-center py-3 text-sm text-on-surface-variant">No slots available for this date</div>
//                     )}
//                   </div>
//                 </div>
//               )}
//               {selectedSlot && (
//                 <div className="bg-primary-fixed/40 p-2 rounded-md mb-4"><p className="text-xs font-semibold">Selected Slot</p><p className="text-primary font-medium text-sm">{selectedDateStringRef.current} - {selectedSlot}</p></div>
//               )}
//               <div className="flex justify-between items-center mt-6 pt-4 border-t border-surface-container">
//                 <button onClick={() => { setShowReschedule(false); setSelectedSlot(""); setAvailableSlots([]); setSelectedDateString(""); selectedDateStringRef.current = ""; }} className="px-4 py-2 rounded-xl bg-surface-low text-on-primary-fixed-var text-sm font-medium hover:bg-surface-container">Cancel</button>
//                 <button onClick={confirmReschedule} disabled={!selectedSlot} className={`px-4 py-2 rounded-xl text-sm font-semibold transition-colors ${selectedSlot ? "bg-primary text-white hover:bg-primary-container" : "bg-surface-container text-on-surface-variant cursor-not-allowed"}`}>Confirm Reschedule</button>
//               </div>
//             </div>
//           )}
//         </Modal>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default MyBookings;


import React, { useState, useEffect, useRef } from "react";
import {
  getMyBookings,
  cancelBooking,
  rescheduleBooking,
  diagReschedule,
  packageReschedule,
} from "../api/bookings.api";
import { getWallet } from "../api/staff.api";
import { apiErrorMessage } from "../utils/apiError";
import { AddToCalendar, CalendarWhen, ViewDirections, normalizeRating } from "../utils/bookingModels";
import { getDiagnosticSlots } from "../api/diagnostics.api";
import { getDoctorSlots } from "../api/doctors.api";
import { getStaffId } from "../utils/storage";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Modal from "../Popups/Modal";
import ConfirmModal from "../Popups/ConfirmModal";
import EmptyState from "../Components/States/EmptyState";
import LoadingState from "../Components/States/LoadingState";
import OfflineState from "../Components/States/OfflineState";
import { isNetworkError } from "../utils/network";
import { toast } from "../Components/Toast";
import { FaMapMarkerAlt, FaFlask, FaXRay, FaStethoscope, FaBox, FaChevronRight, FaCalendarAlt, FaClipboard } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const FILTER_TABS = [
  { id: "all", label: "All" },
  { id: "package", label: "Packages", icon: FaBox },
  { id: "doctor", label: "Doctor", icon: FaStethoscope },
  { id: "xray", label: "Scans", icon: FaXRay },
  { id: "test", label: "Lab Tests", icon: FaFlask },
];
const FILTER_LABEL = { all: "", package: "Package", doctor: "Doctor", xray: "Scan/X-Ray", test: "Lab Test" };

const DetailRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-start justify-between gap-3 py-2.5 border-b border-surface-container/60 last:border-0">
    <span className="flex items-center gap-2 text-sm font-semibold text-on-primary-fixed-var shrink-0">
      <Icon className="text-primary shrink-0" size={14} />
      {label}
    </span>
    <span className="text-sm text-on-surface-variant text-right break-words">{value}</span>
  </div>
);

const filterPillClass = (active) =>
  active
    ? "bg-primary text-white shadow-sm"
    : "bg-surface-lowest text-on-primary-fixed-var border border-primary-fixed-dim/50 hover:bg-surface-low";

const getDiagnosticTitle = (booking, bookingType) => {
  if (booking.cartItems?.length > 0) return booking.cartItems[0].title;
  const kind = bookingType === "xray" ? "X-Ray/Scan" : bookingType === "test" ? "Lab Test" : "Diagnostic";
  if (booking.serviceType === "Home Collection") return `${kind} (Home Collection)`;
  if (booking.serviceType === "Center Visit") return `${kind} (Center Visit)`;
  return `${kind} Consultation`;
};

const getPriceLabel = (bookingType) => {
  if (bookingType === "package") return "Package Price";
  if (bookingType === "doctor") return "Consultation Fee";
  if (bookingType === "xray") return "Scan Cost";
  if (bookingType === "test") return "Test Cost";
  return "Total Cost";
};

const MyBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [networkError, setNetworkError] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState("");
  const staffId = getStaffId();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateString, setSelectedDateString] = useState("");

  const navigate = useNavigate();

  // Filter state
  const [filter, setFilter] = useState('all');

  // Refs for real‑time values
  const selectedDateStringRef = useRef("");
  const selectedBookingRef = useRef(null);

  // Helper: Check if booking can be modified (reschedule/cancel)
  const isBookingModifiable = (booking) => {
    if (!booking) return false;
    // Already cancelled or completed – no buttons
    if (booking.status === "Cancelled" || booking.status === "Completed") return false;

    try {
      // Prefer calendar.start (always a valid ISO string); fall back to date + timeSlot
      const bookingDateTime = new Date(
        booking.calendar?.start || `${booking.date}T${booking.timeSlot}:00`
      );
      if (isNaN(bookingDateTime.getTime())) return false;

      // Only modifiable if the booking is strictly in the future
      return bookingDateTime > new Date();
    } catch (error) {
      console.error("Date parsing error:", error);
      return false;
    }
  };

  useEffect(() => {
    if (!staffId) {
      setError("Staff ID is missing. Please log in again.");
      setLoading(false);
      return;
    }
    fetchBookings();
  }, [staffId]);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      setNetworkError(false);
      setError(null);
      const response = await getMyBookings(staffId);
      if (response.data.success) {
        setBookings(response.data.bookings);
      } else {
        setError("Failed to fetch bookings");
      }
    } catch (err) {
      if (isNetworkError(err)) setNetworkError(true);
      else {
        setError(
          "Error fetching bookings: " +
          (err.response?.data?.message || err.message)
        );
      }
      console.error("Booking fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const getBookingType = (booking) => {
    if (booking.package && booking.package._id) return "package";
    if (booking.diagnosticBookingId) {
      const items = booking.cartItems || [];
      const hasXray = items.some((i) => i.type === "xray");
      const hasTest = items.some((i) => i.type === "test");
      if (hasXray && !hasTest) return "xray";
      if (hasTest && !hasXray) return "test";
      return "diagnostic";
    }
    if (booking.doctorConsultationBookingId || booking.doctorId) return "doctor";
    return "other";
  };

  const bookingTime = (b) => new Date(b.calendar?.start || b.createdAt).getTime();

  const filteredBookings = [...bookings]
    .sort((a, b) => bookingTime(b) - bookingTime(a))
    .filter((booking) => {
      if (filter === 'all') return true;
      const bookingType = getBookingType(booking);
      if (filter === 'package') return bookingType === 'package';
      if (filter === 'doctor') return bookingType === 'doctor';
      if (filter === 'diagnostic') return bookingType === 'diagnostic' || bookingType === 'test' || bookingType === 'xray';
      if (filter === 'xray') return bookingType === 'xray';
      if (filter === 'test') return bookingType === 'test';
      return true;
    });

  const refundLabel = (bucket) => {
    if (bucket === "forDoctors") return "doctors";
    if (bucket === "forPackages") return "packages";
    if (bucket === "forTests") return "tests";
    return "wallet";
  };

  const handleCancelBooking = async (booking) => {
    try {
      const response = await cancelBooking(staffId, booking.bookingId || booking._id, {
        status: "Cancelled",
      });
      const data = response.data || {};
      const amount = data.refundedAmount;
      if (amount != null && amount !== "") {
        toast.success(`₹${amount} refunded to your ${refundLabel(data.refundedTo)} wallet`);
      } else {
        toast.success(data.message || "Booking successfully cancelled.");
      }
      fetchBookings();
      getWallet().catch(() => { });
      setSelectedBooking(null);
    } catch (error) {
      console.error("Cancel Error:", error);
      toast.error(apiErrorMessage(error, "Error while cancelling booking."));
    }
  };

  const formatDateForAPI = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const fetchAvailableSlots = async (dateToUse = null) => {
    const dateString = dateToUse || selectedDateStringRef.current;
    const booking = selectedBookingRef.current;
    if (!booking || !dateString) return;

    setLoadingSlots(true);
    try {
      let response;
      if (booking.diagnosticBookingId && booking.serviceType) {
        const diagnosticId = booking.diagnostic?.diagnosticId?._id;
        if (!diagnosticId) {
          toast.error("Diagnostic center information not found.");
          return;
        }
        response = await getDoctorSlots(booking.doctorId?._id || booking.doctorId, dateString, booking.type);
        if (response.data.slots && response.data.slots.length > 0) {
          setAvailableSlots(response.data.slots);
        } else if (response.data.homeCollectionSlots || response.data.centerVisitSlots) {
          const slots = booking.serviceType === "Home Collection"
            ? response.data.homeCollectionSlots
            : response.data.centerVisitSlots;
          setAvailableSlots(slots || []);
        } else {
          setAvailableSlots([]);
        }
      }
      else if (booking.doctorId) {
        response = await getDoctorSlots(booking.doctorId, dateString, booking.type);
        setAvailableSlots(response.data.slots || []);
      } else {
        toast.error("Cannot reschedule this booking type");
        return;
      }
    } catch (error) {
      console.error("Error fetching slots:", error);
      setAvailableSlots([]);
    } finally {
      setLoadingSlots(false);
    }
  };

  const confirmReschedule = async () => {
    const dateString = selectedDateStringRef.current;
    const booking = selectedBookingRef.current;
    if (!booking || !dateString || !selectedSlot) {
      toast.error("Please select a date and slot before confirming.");
      return;
    }

    try {
      let response;
      const bookingId = booking.bookingId || booking._id;
      if (booking.packageId || booking.packageBookingId) {
        response = await packageReschedule(staffId, bookingId, {
          newDate: dateString,
          newTimeSlot: selectedSlot,
        });
      } else if (booking.diagnosticBookingId) {
        response = await diagReschedule(staffId, bookingId, {
          newDate: dateString,
          newTimeSlot: selectedSlot,
          serviceType: booking.serviceType,
        });
      } else {
        response = await rescheduleBooking(staffId, bookingId, {
          newDay: new Date(dateString).toLocaleDateString("en-US", { weekday: "long" }),
          newDate: dateString,
          newTimeSlot: selectedSlot,
        });
      }
      if (response.data.isSuccessfull || response.data.success) {
        const data = response.data;
        setBookings((prev) => prev.map((item) => {
          const id = item.bookingId || item._id;
          if (id !== bookingId) return item;
          return {
            ...item,
            calendar: data.calendar ?? data.booking?.calendar ?? item.calendar,
            locationUrl: data.locationUrl ?? data.booking?.locationUrl ?? item.locationUrl,
          };
        }));
        toast.success("Booking rescheduled successfully.");
        fetchBookings();
        setShowReschedule(false);
        setSelectedBooking(null);
        selectedBookingRef.current = null;
        setSelectedSlot("");
        setAvailableSlots([]);
        setSelectedDateString("");
        selectedDateStringRef.current = "";
      } else {
        toast.error(response.data.message || "Failed to reschedule booking.");
      }
    } catch (error) {
      console.error("Reschedule Error:", error);
      toast.error("Error while rescheduling booking: " + (error.response?.data?.message || error.message));
    }
  };

  const openGoogleMaps = (address) => {
    if (!address) {
      toast.error("Address not available");
      return;
    }
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, '_blank');
  };

  const handleRescheduleClick = (booking) => {
    selectedBookingRef.current = booking;
    const bookingDate = new Date(booking.date);
    const dateString = formatDateForAPI(bookingDate);
    selectedDateStringRef.current = dateString;

    setSelectedBooking(booking);
    setSelectedDate(bookingDate);
    setSelectedDateString(dateString);
    setSelectedSlot("");
    setAvailableSlots([]);
    setShowReschedule(true);
    fetchAvailableSlots(dateString);
  };

  const handleDateSelect = (date) => {
    const dateString = formatDateForAPI(date);
    selectedDateStringRef.current = dateString;
    setSelectedDate(date);
    setSelectedDateString(dateString);
    setSelectedSlot("");
    fetchAvailableSlots(dateString);
  };

  const generateDateOptions = () => {
    const dates = [];
    const today = new Date();
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };

  const getBookingBadge = (booking) => {
    const bookingType = getBookingType(booking);
    switch (bookingType) {
      case "package":
        return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaBox className="w-3 h-3 mr-1" />, label: "PACKAGE" };
      case "doctor":
        return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaStethoscope className="w-3 h-3 mr-1" />, label: "DOCTOR" };
      case "xray":
        return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaXRay className="w-3 h-3 mr-1" />, label: "X-RAY/SCAN" };
      case "test":
        return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaFlask className="w-3 h-3 mr-1" />, label: "LAB TEST" };
      default:
        return { bg: "bg-primary-fixed/40", text: "text-on-primary-fixed-var", icon: <FaFlask className="w-3 h-3 mr-1" />, label: "DIAGNOSTIC" };
    }
  };

  const getItemTypeBadge = (item) => {
    if (item.type === "xray") {
      return <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-medium rounded-full flex items-center w-fit"><FaXRay className="w-3 h-3 mr-1" />X-RAY/SCAN</span>;
    } else if (item.type === "test") {
      return <span className="px-2 py-1 bg-primary-fixed/40 text-primary-container text-xs font-medium rounded-full flex items-center w-fit"><FaFlask className="w-3 h-3 mr-1" />LAB TEST</span>;
    }
    return null;
  };

  const renderBookingCard = (booking) => {
    const badge = getBookingBadge(booking);
    const bookingType = getBookingType(booking);
    const amount = booking.payableAmount || booking.totalPrice || "—";
    const bookingId =
      booking.diagnosticBookingId || booking.doctorConsultationBookingId || booking.bookingId || "—";
    const dateTime = `${formatDateForDisplay(booking.date)}${booking.timeSlot ? `, ${booking.timeSlot}` : ""}`;

    let title;
    let detailRows;
    let highlight = null;

    if (bookingType === "package") {
      title = booking.package?.name || "Health Package";
      detailRows = [
        { icon: FaFlask, label: "Total Tests", value: booking.package?.totalTestsIncluded || 0 },
        { icon: FaMapMarkerAlt, label: "Type", value: booking.serviceType || "Diagnostic" },
        { icon: FaClipboard, label: "Booking ID", value: bookingId },
        { icon: FaCalendarAlt, label: "Date & Time", value: dateTime },
      ];
      if (booking.package) {
        highlight = (
          <div className="bg-primary-fixed/30 rounded-xl p-4 text-center">
            <p className="text-sm font-semibold text-on-primary-fixed-var">
              Package Includes {booking.package.totalTestsIncluded} Tests
            </p>
            <p className="text-xs text-on-surface-variant mt-1 leading-relaxed">
              Comprehensive health screening package
            </p>
          </div>
        );
      }
    } else if (bookingType === "doctor") {
      title = booking.doctor?.name || "Doctor Consultation";
      detailRows = [
        {
          icon: FaStethoscope,
          label: "Consultation",
          value: booking.type === "Online" ? "Online" : booking.type === "Offline" ? "Clinic Visit" : "Consultation",
        },
        { icon: FaClipboard, label: "Booking ID", value: bookingId },
        { icon: FaCalendarAlt, label: "Date & Time", value: dateTime },
      ];
      if (booking.doctor?.specialization) {
        detailRows.push({ icon: FaStethoscope, label: "Specialization", value: booking.doctor.specialization });
      }
    } else {
      title = getDiagnosticTitle(booking, bookingType);
      const itemCount = booking.cartItems?.length || 0;
      detailRows = [
        { icon: FaFlask, label: "Total Items", value: itemCount || "—" },
        {
          icon: FaMapMarkerAlt,
          label: "Type",
          value: booking.serviceType === "Home Collection" ? "Home Collection" : "Center Visit",
        },
        { icon: FaClipboard, label: "Booking ID", value: bookingId },
        { icon: FaCalendarAlt, label: "Date & Time", value: dateTime },
      ];
      // if (booking.serviceType === "Center Visit" && booking.diagnostic?.address) {
      //   highlight = (
      //     <div className="bg-primary-fixed/30 rounded-xl p-4 text-center">
      //       <p className="text-xs text-on-surface-variant mb-1">Center Address</p>
      //       <button
      //         type="button"
      //         onClick={() => openGoogleMaps(booking.diagnostic.address)}
      //         className="text-sm font-medium text-primary hover:underline leading-relaxed break-words"
      //       >
      //         {booking.diagnostic.address}
      //       </button>
      //     </div>
      //   );
      // }
    }

    return (
      <div
        key={booking.bookingId || booking._id}
        className="rounded-2xl border border-surface-container bg-surface-lowest shadow-sm p-4 space-y-3"
      >
        <div>
          <div className="flex items-center justify-between">
            <span className={`inline-flex items-center ${badge.bg} ${badge.text} text-xs font-semibold px-2.5 py-1 rounded-md mb-2`}>
              {badge.icon}
              {badge.label}
            </span>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${booking.status === "Cancelled" ? "bg-error-container text-error" : "bg-primary-fixed/30 text-primary"
                }`}
            >
              {booking.status}
            </span>
          </div>
          <div className="flex items-start justify-between gap-3 mt-2">
            <h3 className="font-bold text-on-primary-fixed-var text-base leading-snug break-words flex-1">{title}</h3>
            <div className="text-right shrink-0">
              <p className="text-lg font-bold text-primary">₹{amount}</p>
              <p className="text-xs text-on-surface-variant">{getPriceLabel(bookingType)}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-surface-container/60 pt-1">
          {detailRows.map((row) => (
            <DetailRow key={row.label} icon={row.icon} label={row.label} value={row.value} />
          ))}
        </div>

        {highlight}

        <div className="border-t border-surface-container/60 pt-3 space-y-2">
          <p className="font-bold text-on-primary-fixed-var">₹{amount}</p>
          <p className="text-sm text-on-surface-variant">
            {formatDateForDisplay(booking.date)}
            {booking.timeSlot ? ` · ${booking.timeSlot}` : ""}
          </p>
          <button
            type="button"
            onClick={() => setSelectedBooking(booking)}
            className="w-full min-h-[48px] bg-primary text-white rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-primary-container transition-colors"
          >
            Booking Details
            <FaChevronRight size={12} />
          </button>
        </div>
      </div>
    );
  };

  const renderPackageBookingDetails = (booking) => {
    const badge = getBookingBadge(booking);
    return (
      <div className="space-y-4 text-sm">
        <div className={`${badge.bg} p-3 rounded-lg`}>
          <div className="flex items-center">{badge.icon}<span className="font-bold ml-2">{badge.label}</span></div>
        </div>
        <div className="bg-surface-low p-4 rounded-lg">
          <h4 className="font-bold text-on-primary-fixed-var text-base mb-3">{booking.package?.name}</h4>
          <div className="grid grid-cols-2 gap-4 py-3 border-b border-surface-container">
            <div><p className="text-xs text-on-surface-variant mb-1">Total Tests</p><p className="font-semibold text-primary">{booking.package?.totalTestsIncluded}</p></div>
            <div><p className="text-xs text-on-surface-variant mb-1">Service Type</p><p className="font-semibold">{booking.serviceType}</p></div>
            <div><p className="text-xs text-on-surface-variant mb-1">Original Price</p><p className="font-semibold">₹{booking.package?.price}</p></div>
            <div><p className="text-xs text-on-surface-variant mb-1">Paid Amount</p><p className="font-semibold text-primary">₹{booking.payableAmount}</p></div>
          </div>
          {booking.package?.description && (
            <div className="mt-3 pt-3"><p className="text-xs text-on-surface-variant mb-1">Description</p><p className="text-sm text-on-primary-fixed-var leading-relaxed">{booking.package.description}</p></div>
          )}
        </div>
        <div className="space-y-3">
          <div className="flex justify-between"><span className="font-semibold">Booking ID</span><span className="font-mono">{booking.bookingId || booking.bookingId}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Date & Time</span><span>{formatDateForDisplay(booking.date)} - {booking.timeSlot}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Status</span><span className={`font-semibold ${booking.status === 'Confirmed' ? 'text-primary' : 'text-yellow-600'}`}>{booking.status}</span></div>
        </div>
        {booking.staff && (
          <div className="bg-primary-fixed/30 p-3 rounded mt-3"><p className="text-xs text-on-surface-variant mb-1">Booked By</p><p className="font-medium">{booking.staff.name}</p><p className="text-sm text-on-surface-variant">{booking.staff.email}</p></div>
        )}
      </div>
    );
  };

  const renderDiagnosticBookingDetails = (booking) => {
    const badge = getBookingBadge(booking);
    return (
      <div className="space-y-4 text-sm">
        <div className={`${badge.bg} p-3 rounded-lg`}>
          <div className="flex items-center">{badge.icon}<span className="font-bold ml-2">{badge.label}</span></div>
        </div>
        <div className="space-y-3">
          <div className="flex justify-between"><span className="font-semibold">Service Type</span><span>{booking.serviceType === "Home Collection" ? "Home Collection" : "Center Visit"}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Booking ID</span><span className="font-mono">{booking.diagnosticBookingId}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Date & Time</span><span>{formatDateForDisplay(booking.date)} - {booking.timeSlot}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Total Amount</span><span className="font-semibold text-primary">₹{booking.payableAmount || booking.totalPrice}</span></div>
        </div>
        {booking.diagnostic && (
          <div className="bg-surface-low p-3 rounded-lg">
            <p className="text-xs text-on-surface-variant mb-1">Diagnostic Center</p>
            <p className="font-semibold">{booking.diagnostic.name}</p>
            {booking.serviceType === "Center Visit" && booking.diagnostic.address && (
              <div className="mt-2"><p className="text-xs text-on-surface-variant mb-1">Address</p><p className="text-sm text-primary-container cursor-pointer hover:text-primary transition-colors" onClick={() => openGoogleMaps(booking.diagnostic.address)}><FaMapMarkerAlt className="inline-block mr-1" />{booking.diagnostic.address}</p></div>
            )}
          </div>
        )}
        {booking.cartItems && booking.cartItems.length > 0 && (
          <div className="bg-surface-lowest border rounded-lg p-3">
            <p className="font-semibold mb-2">Booked Items</p>
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {booking.cartItems.map((item, index) => (
                <div key={index} className="border-b pb-2 last:border-0">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center mb-1">{getItemTypeBadge(item)}<span className="ml-2 font-medium">{item.title}</span></div>
                      <div className="grid grid-cols-2 gap-2 text-xs text-on-surface-variant">
                        <div>Quantity: {item.quantity}</div>
                        <div>Price: ₹{item.price}</div>
                        <div>Offer: ₹{item.offerPrice}</div>
                        <div>Total: ₹{item.totalPrice}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="pt-2 border-t mt-2"><div className="flex justify-between font-semibold"><span>Total Items:</span><span>{booking.cartItems.length}</span></div><div className="flex justify-between font-semibold text-primary"><span>Total Amount:</span><span>₹{booking.payableAmount || booking.totalPrice}</span></div></div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderDoctorBookingDetails = (booking) => {
    const badge = getBookingBadge(booking);

    const Doctor = booking.doctor;

    return (
      <div className="space-y-4 text-sm">
        <div className={`${badge.bg} p-3 rounded-lg`}>
          <div className="flex items-center">{badge.icon}<span className="font-bold ml-2">{badge.label}</span></div>
        </div>
        <div className="space-y-3">
          <div className="flex justify-between"><span className="font-semibold">Consultation Type</span><span>{booking.type === "Online" ? "Online Consultation" : "Clinic Visit"}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Booking ID</span><span className="font-mono">{booking.bookingId || booking.bookingId}</span></div>
          <div className="flex justify-between"><span className="font-semibold">Date & Time</span><span>{formatDateForDisplay(booking.date)} - {booking.timeSlot}</span></div>
          {booking.patient && <div className="flex justify-between"><span className="font-semibold">Family Member</span><span>{booking.patient.name}</span></div>}
          <div className="flex justify-between"><span className="font-semibold">Consultation Fee</span><span className="font-semibold text-primary">₹{booking.payableAmount || booking.totalPrice}</span></div>
        </div>
        {booking.type === "Online" && booking.bookingId && (
          <button
            type="button"
            onClick={() =>
              navigate(`/consultations/video/${booking.bookingId}`, {
                state: { doctor: booking.doctor },
              })
            }
            className="w-full min-h-[48px] bg-primary text-white rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-primary-container transition-colors"
          >
            Join Video Call
          </button>
        )}
        {booking.doctor && (
          <div className="bg-surface-low p-3 rounded-lg">
            <p className="text-xs text-on-surface-variant mb-1">Doctor Details</p>
            <p className="font-semibold">{booking.doctor.name}</p>
            {normalizeRating(booking.doctor.rating) > 0 && (
              <p className="text-sm text-on-surface-variant">Rating {normalizeRating(booking.doctor.rating).toFixed(1)}</p>
            )}
            <p className="text-sm text-on-surface-variant">{booking.doctor.qualification}</p>
            <p className="text-sm text-on-surface-variant">{booking.doctor.specialization}</p>
            {booking.type === "Offline" && booking.doctor.address && (
              <div className="mt-2"><p className="text-xs text-on-surface-variant mb-1">Clinic Address</p><p className="text-sm text-primary-container cursor-pointer hover:text-primary transition-colors" onClick={() => openGoogleMaps(booking.doctor.address)}><FaMapMarkerAlt className="inline-block mr-1" />{booking.doctor.address}</p></div>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderBookingLinks = (booking) => {
    const locationUrl = booking.locationUrl || booking.doctor?.locationUrl || booking.diagnostic?.locationUrl;
    return (
      <div className="space-y-2">
        <CalendarWhen calendar={booking.calendar} />
        <div className="flex flex-col sm:flex-row gap-2">
          {/* <AddToCalendar calendar={booking.calendar} className="flex-1 text-center" /> */}
          <ViewDirections url={locationUrl} className="flex-1 text-center" />
        </div>
      </div>
    );
  };

  const renderBookingDetails = (booking) => {
    const bookingType = getBookingType(booking);
    let body = renderDiagnosticBookingDetails(booking);
    if (bookingType === "package") body = renderPackageBookingDetails(booking);
    else if (bookingType === "doctor") body = renderDoctorBookingDetails(booking);
    return (
      <div className="space-y-4">
        {body}
        {renderBookingLinks(booking)}
      </div>
    );
  };

  useEffect(() => {
    selectedDateStringRef.current = selectedDateString;
  }, [selectedDateString]);

  useEffect(() => {
    selectedBookingRef.current = selectedBooking;
  }, [selectedBooking]);

  if (loading) {
    return <LoadingState fullPage withHeader withFooter message="Loading your bookings…" />;
  }

  if (networkError) {
    return (
      <div className="min-h-screen bg-surface-low flex flex-col">
        <Header />
        <OfflineState onRetry={fetchBookings} className="flex-1" />
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-surface-low flex flex-col">
        <Header />
        <div className="flex-1 flex flex-col items-center justify-center text-lg text-red-500 px-4">
          <p>{error}</p>
          <button onClick={fetchBookings} type="button" className="mt-4 bg-primary text-white py-2 px-4 rounded-md">Try Again</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface-low flex flex-col">
      <Header />
      <div className="flex flex-col min-h-screen pb-16 lg:pb-0 flex-1">
        <div className="max-w-2xl mx-auto w-full px-3 sm:px-4 py-4 sm:py-8">
          <div className="sticky top-0 z-20 bg-surface-low -mx-3 px-3 pt-2 pb-3 border-b border-surface-container/60 lg:static lg:mx-0 lg:px-0 lg:border-0 lg:pb-0">
            <h1 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var">My Bookings</h1>
            {/* <p className="text-xs sm:text-sm text-on-surface-variant mt-0.5 font-normal">
              View and manage your health appointments
            </p> */}

            <div className="relative mt-4">
              <div className="flex gap-2 overflow-x-auto snap-x snap-mandatory pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                {FILTER_TABS.map(({ id, label, icon: Icon }) => (
                  <button
                    key={id}
                    type="button"
                    onClick={() => setFilter(id)}
                    className={`shrink-0 snap-start inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-medium min-h-[44px] transition-colors ${filterPillClass(filter === id)}`}
                  >
                    {Icon && <Icon className="w-3 h-3" />}
                    {label}
                  </button>
                ))}
              </div>
              <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-surface-low to-transparent lg:hidden" />
              <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-surface-low to-transparent lg:hidden" />
            </div>

            <p className="text-xs text-on-surface-variant mt-2 text-right">
              {filteredBookings.length} booking{filteredBookings.length !== 1 ? "s" : ""} found
            </p>
          </div>

          {bookings.length === 0 ? (
            <EmptyState
              title="No bookings found yet."
              description="Your health appointments will appear here once you book a consultation, lab test, or package."
              actionLabel="Browse Lab Tests"
              actionTo="/lab-tests"
            />
          ) : (
            <div className="space-y-4 mt-4">
              {filteredBookings.length === 0 ? (
                <EmptyState
                  title={`No ${FILTER_LABEL[filter] ? FILTER_LABEL[filter] + " " : ""}bookings found`}
                  description="Try a different filter to see your appointments."
                  actionLabel={filter !== "all" ? "View all bookings" : undefined}
                  onAction={filter !== "all" ? () => setFilter("all") : undefined}
                />
              ) : (
                filteredBookings.map((booking) => renderBookingCard(booking))
              )}
            </div>
          )}
        </div>

        {/* Booking Details Modal */}
        <Modal
          open={!!selectedBooking && !showReschedule}
          onClose={() => { setSelectedBooking(null); selectedBookingRef.current = null; }}
          className="max-w-lg w-full rounded-t-2xl sm:rounded-2xl h-[min(92vh,100%)] sm:h-auto sm:max-h-[90vh] overflow-y-auto"
          align="bottom"
          closeSize={24}
        >
          {selectedBooking && (
            <div className="p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-bold text-on-primary-fixed-var mb-4 pr-10">
                {(() => {
                  const bookingType = getBookingType(selectedBooking);
                  if (bookingType === 'package') return "Health Package Details";
                  if (bookingType === 'doctor') return "Doctor Consultation Details";
                  if (bookingType === 'xray') return "X-Ray/Scan Details";
                  if (bookingType === 'test') return "Lab Test Details";
                  return "Diagnostic Booking Details";
                })()}
              </h3>

              {renderBookingDetails(selectedBooking)}

              <div className="mt-6 space-y-2">
                {isBookingModifiable(selectedBooking) && (
                  <>
                    <button
                      onClick={() => handleRescheduleClick(selectedBooking)}
                      className="w-full border border-primary text-primary py-2.5 rounded-xl text-sm font-semibold hover:bg-primary-fixed/30"
                    >
                      Reschedule Booking
                    </button>
                    <button
                      onClick={() => setShowCancelConfirm(true)}
                      className="w-full border border-red-300 text-error py-2.5 rounded-xl text-sm font-semibold hover:bg-red-50"
                    >
                      Cancel Booking
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
        </Modal>

        <ConfirmModal
          open={showCancelConfirm}
          onCancel={() => setShowCancelConfirm(false)}
          onConfirm={() => {
            handleCancelBooking(selectedBooking);
            setShowCancelConfirm(false);
            setSelectedBooking(null);
            selectedBookingRef.current = null;
          }}
          title="Cancel this booking?"
          message="Are you sure you want to cancel this booking? This action cannot be undone."
          confirmLabel="Yes, Cancel"
          cancelLabel="Keep Booking"
        />

        {/* Reschedule Modal */}
        <Modal
          open={showReschedule && !!selectedBooking}
          onClose={() => { setShowReschedule(false); setSelectedSlot(""); setAvailableSlots([]); setSelectedDateString(""); selectedDateStringRef.current = ""; }}
          className="max-w-lg w-full rounded-t-2xl sm:rounded-2xl h-[min(92vh,100%)] sm:h-auto sm:max-h-[90vh] overflow-y-auto"
          align="bottom"
          closeSize={24}
        >
          {selectedBooking && (
            <div className="p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-bold text-on-primary-fixed-var mb-4 pr-10">Reschedule Booking</h3>
              <div className="bg-primary-fixed/40 p-3 rounded-md mb-4"><p className="text-sm font-semibold">Current Booking</p><p className="text-primary-container font-medium text-sm">{formatDateForDisplay(selectedBooking.date)} - {selectedBooking.timeSlot}</p></div>
              <div className="flex space-x-2 overflow-x-auto mb-4 pb-2">
                {generateDateOptions().map((date, i) => {
                  const dateString = formatDateForAPI(date);
                  const isSelected = selectedDateStringRef.current === dateString;
                  return (
                    <button key={i} onClick={() => handleDateSelect(date)} className={`flex flex-col items-center min-w-[50px] px-2 py-2 rounded-md ${isSelected ? "bg-primary text-white" : "bg-surface-low text-on-primary-fixed-var"}`}>
                      <span className="text-xs font-medium">{date.toLocaleDateString("en-US", { weekday: "short" })}</span>
                      <span className="text-base font-semibold">{date.getDate()}</span>
                      <span className="text-xs text-on-surface-variant">{date.getMonth() + 1}/{date.getFullYear()}</span>
                    </button>
                  );
                })}
              </div>
              {loadingSlots && <LoadingState size="sm" message="Loading available slots…" className="py-3" />}
              {!loadingSlots && (
                <div>
                  <p className="text-sm font-medium mb-2">Available Time Slots</p>
                  <div className="grid grid-cols-2 gap-2 mb-4">
                    {availableSlots.length > 0 ? (
                      availableSlots.map((slot) => (
                        <button key={slot._id || slot.timeSlot} onClick={() => setSelectedSlot(slot.timeSlot)} disabled={slot.isBooked} className={`p-2 rounded-md text-xs transition-colors ${slot.isBooked ? "bg-error-container text-error cursor-not-allowed" : selectedSlot === slot.timeSlot ? "bg-primary text-white" : "bg-surface-low text-on-primary-fixed-var hover:bg-surface-container"}`}>
                          <div className="font-medium">{slot.timeSlot}</div>
                          {slot.isBooked && <div className="text-xs mt-1 text-red-500">Booked</div>}
                        </button>
                      ))
                    ) : (
                      <div className="col-span-2 text-center py-3 text-sm text-on-surface-variant">No slots available for this date</div>
                    )}
                  </div>
                </div>
              )}
              {selectedSlot && (
                <div className="bg-primary-fixed/40 p-2 rounded-md mb-4"><p className="text-xs font-semibold">Selected Slot</p><p className="text-primary font-medium text-sm">{selectedDateStringRef.current} - {selectedSlot}</p></div>
              )}
              <div className="flex justify-between items-center mt-6 pt-4 border-t border-surface-container">
                <button onClick={() => { setShowReschedule(false); setSelectedSlot(""); setAvailableSlots([]); setSelectedDateString(""); selectedDateStringRef.current = ""; }} className="px-4 py-2 rounded-xl bg-surface-low text-on-primary-fixed-var text-sm font-medium hover:bg-surface-container">Cancel</button>
                <button onClick={confirmReschedule} disabled={!selectedSlot} className={`px-4 py-2 rounded-xl text-sm font-semibold transition-colors ${selectedSlot ? "bg-primary text-white hover:bg-primary-container" : "bg-surface-container text-on-surface-variant cursor-not-allowed"}`}>Confirm Reschedule</button>
              </div>
            </div>
          )}
        </Modal>
        <Footer />
      </div>
    </div>
  );
};

export default MyBookings;